<template>
  <div>
    <div class="city" v-if="!isFleetPCFunnel">
      <div class="search-city-wrapper">
        <div class="search-city">
          <i class="cubeic-search"></i>
          <input
            ref="city_input"
            type="text"
            v-model="inputTxt"
            @keyup="handleKeyUp"
            @click="handleClickInput"
            :placeholder="$t('city.placeholder')"
          />
        </div>
      </div>
      <div class="location-city" v-show="!inputTxt && [areaType.state].text" v-if="showTypeInfo">
        <div class="cityList-key"><span>{{$t("city.location")}}</span></div>
        <div class="cityList-item active" @click="handleClick('chooseCity',[areaType.state])"><span>{{[areaType.state].text}}</span></div>
      </div>
      <div class="cityList" :class="{'no-padding': isFleetFunnel}" v-if="showTypeInfo">
        <cube-scroll
          ref="scroll"
          :data="showCityList"
          @pulling-up="addData"
          :options="{pullUpLoad: {threshold: 0}}"
        >
          <div v-for="(item,key) in showCityList" :key="key">
            <div class="cityList-key" v-if="item.header&&!inputTxt"><span>{{item.text}}</span></div>
            <div
              v-if="!item.header"
              class="cityList-item"
              :key="item.value"
              @click="handleClick('chooseCity',item)"
            ><span>{{item.text}}</span></div>
          </div>
        </cube-scroll>
      </div>
      <div v-if="!showTypeInfo">
        <ul>
          <li class="otherCityTxt" v-for="(item, idx) in otherCityTextList" :key="idx" v-html="item"></li>
        </ul>
      </div>
      <!-- <div class="cityList" v-show="inputTxt">
        <ul class="cityList-ul" v-show="filterData.length">
          <li
            class="cityList-item"
            v-for="item in filterData"
            :key="item.value"
            @click="handleClick('chooseCity',item)"
          >{{item.text}}</li>
        </ul>
        <div v-show="!filterData.length">
        </div>
      </div>-->
    </div>
    <el-select
      v-else
      v-model="cityId"
      filterable
      value-key="value"
      :placeholder="placeholder"
      :no-match-text="' '"
      :no-data-text="' '"
      class="select-city"
      @change="elSelectChange">
      <el-option
        v-for="item in cityList"
        :key="item.value"
        :label="item.text"
        :value="item">
        <!-- <span v-if="!item.header">{{item.text}}</span> -->
      </el-option>
    </el-select>
  </div>
  
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { showAlertDialog, showDialog } from "../../tools/Tip";
import { openWebview } from '../../tools/utils'
import { ends, AREA_TYPE } from '../../tools/constant'
import { SERVICE_PHONE } from "../../tools/constant";
const TIMEOUT = 100;
const OTHER_CITY_ID = 12345678;
export default {
  props: ["selfClose", "parentCom", "fleetOpenCity", "ob_driver_id", "page_style", "placeholder", "item"],
  data() {
    return {
      cityList: [],
      showCityList: [],
      loadCityList: [],
      // filterData: [],
      inputTxt: "",
      size: 50,
      idx: 1,
      showTypeInfo: true,
      cityId: ''
    };
  },
  computed: {
    ...mapState(["_ticket", "_area"]),
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    otherCityTextList() {
      const arr = [
        this.$t("typeInfo.other_city_txt1"),
        this.$t("typeInfo.other_city_txt2"),
      ];
      let TEL = SERVICE_PHONE[this.location_country] || "";
      return arr.map((item) => {
        return item.replace(
          /\{tel\}/,
          `<a href=tel:${TEL} style="color:#FF7226">${TEL}</a>`
        );
      });
    },
    isPreviewPage() {
      let up = new URLSearchParams(location.search);
      return up.get('ob_page_type') === 'preview';
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    areaType() {
      if (this.item) {
        return AREA_TYPE[this.item.type];
      } else {
        return {
          state: '_area',
          state_open_type: '_open_type',
        };
      }
    }
  },
  watch: {
    _area: {
      handler(newV, oldV) { 
        if (!this.item) {
          return false;
        }
        if (this.item.type === 'select') {
          this.setState({
            _city: {},
            _city_open_type: ""
          });
        }
        if (this.item.type === 'select_county' && this.item.is_linked === true && this.item.citys.split(',').includes(newV.value.toString())) {
          this.getList();
        }
      },
      deep: true,
      immediate: true, //页面初始化时立即调用
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    addData() {
      let len = this.loadCityList.length;
      let limit = this.size * this.idx;
      if (limit < len) {
        this.idx++;
        limit += this.size;
        this.showCityList = this.loadCityList.slice(0, limit);
      } else {
        this.$refs.scroll.forceUpdate();
      }
    },
    goBack() {
      if (this.selfClose) {
        this.$emit("close");
        if (this.isFleetPCFunnel) {
          return;
        }
        this.inputTxt = "";
        this.filterCity();
        if (this.$refs.city_input) {
          this.$refs.city_input.blur();
        }
        return;
      }
      setTimeout(() => {
        this.$router.go(-1);
      }, TIMEOUT);
    },
    handleClickInput() {
      if (!this.showTypeInfo) {
        this.showTypeInfo = true;
        this.inputTxt = "";
        this.filterCity();
      }
    },
    handleKeyUp() {
      clearTimeout(this.tid);
      this.tid = setTimeout(() => {
        this.filterCity();
      }, 150);
    },
    filterCity() {
      //每次搜索后均做重置操作
      this.$refs.scroll && this.$refs.scroll.scrollTo(0,0);
      this.idx = 1;
      this.loadCityList = this.cityList.filter((item, index) => {
        return (
          item.text
            .toLowerCase()
            .indexOf(this.inputTxt.trim().toLowerCase()) === 0
        );
      });
      this.showCityList = this.loadCityList.slice(0, this.size);
    },
    handleClick(tag, item) {
      switch (tag) {
        case "chooseCity":
          Omega.trackEvent("ibt_register_basicinfo_city_ck", "", {
            ob_driver_id: this.ob_driver_id,
            area_id: item.value,
            area_text: item.text
          });

          if (this.fleetOpenCity && this.fleetOpenCity.length) {
            let inFleetOpenCity = this.fleetOpenCity.some(city => city === item.value)
            if (!inFleetOpenCity) {
              this.cityId = ''
              showDialog(this, {
                type: "confirm",
                title: '',
                content: this.$t('GDriver_fleet_We_are_epJa'),
                confirmBtn: {
                  text: this.$t("GDriver_fleet_Fill_in_hdrA"),
                },
                cancelBtn: { text: this.$t("GDriver_fleet_Cancel_rEEA") },
                onConfirm: () => {
                  let url = 'https://99app.force.com'
                  if (ends.inApp) {
                    openWebview(url)
                  } else {
                    window.open(url)
                  }
                },
                // onCancel: () => {
                //   Omega.trackEvent("toggle_CNH_update_popup_no");
                // }
              });
              return
            }
          }
          this.inputTxt = item.text;
          this.setState({
            [this.areaType.state]: item
          });
          if (this._area.value === OTHER_CITY_ID) {
            this.showTypeInfo = false;
          } else {
            this.goBack();
          }
          break;
        default:
          break;
      }
    },
    elSelectChange(v) {
      // console.log(v)
      this.handleClick('chooseCity', v)
    },
    getList() {
      let up = new URLSearchParams(location.search);
      let apiUrl = '';
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this.isPreviewPage) {
        up.set("iDriverId", '650910921100653');
      }
      if (this.item && this.item.type === 'select_county') {
        up.set("city_id", this._area.value);
      }
      if (this.parentCom && this.parentCom === "landingPage") {
        up.set("area_id", this._area.value || '');
        apiUrl = process.env.LANDING_PAGE_GET_CITY_LIST;
      } else if(this.isPreviewPage){
        apiUrl = this.item && this.item.type === 'select'? process.env.GET_CITYLIST_PRE : process.env.GET_COUNTYLIST_PRE;
      } else {
        apiUrl = this.item && this.item.type === 'select'? process.env.GET_CITYLIST : process.env.GET_COUNTYLIST;
      }
      post(apiUrl, up)
        .then(data => {
          let list = [];
          let city_list = data.list;
          // @20191218 解决API城市传值问题
          this.setState({
            [this.areaType.state_open_type]: data.open_type
          });
          let keys = Object.keys(city_list);
          keys.forEach(key => {
            if (!this.isFleetPCFunnel) {
              list.push({
                header: 1,
                text: key
              });
            }
            let arr = city_list[key];
            arr.forEach((item, index) => {
              item.header = 0;
            });
            list = list.concat(arr);
          });
          this.showCityList = list.slice(0, this.size);
          this.cityList = list;
          // console.log(list)
          this.loadCityList = list;
        })
        .catch(err => {
          Omega.trackError("tech_ibt_onboarding_landingpagetcitylist_bt", err.errno, err.errmsg, {
              url: apiUrl,
              resp: err,
              desc: 'new landingpage获取城市列表报错'
          });
          showAlertDialog(this)
        });
    }
  },
  mounted() {
    if (!this.item || (this.item && this.item.type === 'select')) {
      this.getList()
    }
  }
};
</script>
<style lang="scss" scoped>
.city {
  background: #fff;
  color: #323233;
  .search-city-wrapper {
    width: 100%;
    box-sizing: border-box;
    font-size: 0.4rem;
    padding: 0.2096rem 0.22rem 0.2096rem 0.4rem;
    .search-city {
      box-sizing: border-box;
      padding: 0.2rem 0.36rem;
      position: relative;
      &:after {
        content: "";
        pointer-events: none;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        box-sizing: border-box;
        border: 1px solid #e1e2e6;
        width: 200%;
        height: 200%;
        transform: scale(0.5) translateZ(0);
      }
      i {
        color: #c3c3c3;
        vertical-align: middle;
        position: absolute;
        width: 0.4rem;
        height: 0.4rem;
        left: 0.32rem;
        top: 0.24rem;
      }
      input {
        width: 100%;
        padding-left: 0.48rem;
        box-sizing: border-box;
        font-weight: 100;
        &::-webkit-input-placeholder {
          color: #999;
        }
      }
    }
  }
  .cityList-key {
    padding: 0.28rem 0.45rem;
    background: #f5f5f7;
    color: #646466;
    font-size: 0.28rem;
  }
  .cityList-item {
    padding: 0.28rem 0.45rem;
    font-size: 0.36rem;
    color: #323233;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:last-child {
      &::after {
        display: none;
      }
    }
    &:after {
      content: "";
      pointer-events: none;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      transform-origin: 0 0;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border-bottom: 1px solid #e1e2e6;
      width: 200%;
      height: 200%;
      transform: scale(0.5) translateZ(0);
    }
    &.active {
      color: #ff7226;
      &::after {
        display: none;
      }
    }
  }
  .cityList {
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 0.7rem;
    // height: 10.5rem;
    height: 100vh;
    padding-bottom: 2rem;
    background: #fff;
    border-left: 1px solid #e1e2e6;
    text-align: left;
    &.no-padding {
      height: calc(100vh - 2.5rem);
      // height: 100vh;
      // padding-bottom: 4rem;
    }
  }
  .otherCityTxt {
    padding: 0 0.32rem;
    margin-bottom: 0.36rem;
    line-height: 1.3;
    font-size: 0.4rem;
  }
}
.select-city {
  width: 100%;
  position: absolute;
  bottom: 8px;
  // opacity: 0;
  ::v-deep .el-input {
    margin-bottom: 16px;
    input {
        height: 20px;
        padding: 0;
        font-size: 16px !important;
        font-weight: 700;
        border: none;
        background: transparent;
        color: #333333;
    }
    input::placeholder {
      color: #CCCCCC;
    }
    .el-input__suffix {
        display: none;
    }
  }
}
</style>
